import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "as-statistics__content" }
const _hoisted_2 = { class: "as-statistics__title" }

import { computed, PropType, inject, ref, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces/tennis";
import { getProcessedStats } from "~src/helpers/tennis/index";
import StatsEnum from "~src/enums/tennis/StatsEnum";

const __default__ = {};

interface IProps {
  statistics: IStatistics;
  match: IMatch;
  isHomePage: boolean;
  isDefault: boolean;
}

interface IProcessedStat {
  type?: string;
  home?: string | number;
  away?: string | number;
  showHomePre?: string;
  showAwayPre?: string;
  winHome?: string;
  winAway?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StatisticsItem',
  props: {
    statistics: {},
    match: {},
    isHomePage: { type: Boolean, default: false },
    isDefault: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const processedStats = computed<IProcessedStat[]>(() => {
  let data = getProcessedStats(props.match, props.statistics, props.isDefault);
  data.forEach((item: any, index: number) => {
    let _winHome = "";
    let _winAway = "";
    let _home = data[index]["home"];
    let _away = data[index]["away"];
    let _percentHome = _home;
    let _percentAway = _away;
    if (StatsEnum.showPreKeys.includes(item.key)) {
      if (typeof _home === "string") {
        let [_success, _total] = _home.split("/").map(Number);
        _percentHome = Number(((_success / _total) * 100).toFixed(1));
        data[index]["showHomePre"] = `${_percentHome}%`;
      }

      if (typeof _away === "string") {
        let [__success, __total] = _away.split("/").map(Number);
        _percentAway = Number(((__success / __total) * 100).toFixed(1));
        data[index]["showAwayPre"] = `${_percentAway}%`;
      }
    }
    if (StatsEnum.percentKeys.includes(item.key)) {
      data[index]["home"] = `${_home}%`;
      data[index]["away"] = `${_away}%`;
      data[index]["showHomePre"] = `${_home}%`;
      data[index]["showAwayPre"] = `${_away}%`;
    }

    _winHome = _percentHome > _percentAway ? "as-statistics__home-win" : "";
    _winAway = _percentHome < _percentAway ? "as-statistics__away-win" : "";

    data[index]["winHome"] = _winHome;
    data[index]["winAway"] = _winAway;
  });

  return data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-statistics", {
      'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
        !_ctx.isHomePage,
      'as-home-scrollable-content': _ctx.isHomePage,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedStats.value, (stat, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "as-statistics__line",
          key: key
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["as-statistics__value as-statistics__value--home", stat.winHome])
          }, _toDisplayString(stat.home), 3),
          _createElementVNode("span", {
            class: _normalizeClass(["as-statistics__bar-wrapper as-statistics__bar-wrapper--home", stat.winHome])
          }, [
            _createElementVNode("span", {
              class: "as-statistics__bar as-statistics__bar--home",
              style: _normalizeStyle({ width: stat.showHomePre || 50 })
            }, null, 4)
          ], 2),
          _createElementVNode("span", _hoisted_2, _toDisplayString(stat.type), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["as-statistics__bar-wrapper as-statistics__bar-wrapper--away", stat.winAway])
          }, [
            _createElementVNode("span", {
              class: "as-statistics__bar as-statistics__bar--away",
              style: _normalizeStyle({ width: stat.showAwayPre || 40 })
            }, null, 4)
          ], 2),
          _createElementVNode("span", {
            class: _normalizeClass(["as-statistics__value as-statistics__value--away", stat.winAway])
          }, _toDisplayString(stat.away), 3)
        ]))
      }), 128))
    ])
  ], 2))
}
}

})